import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '@components/base/BaseComponent/BaseComponent';

import ComponentCart from "../../components/ComponentCart/ComponentCart";
import ComponentBreadcrumb from "../../components/ComponentBreadcrumb/ComponentBreadcrumb";

import styles from './ComponentHeader.scss';
import {ContextDataStore} from "@helpers/HelperGlobalDataStore";

class ComponentHeader extends BaseComponent {
	cart = React.createRef();

	render() {
		const cart = this.context.get('ComponentCart');
		const breadcrumb = this.context.get('ComponentBreadcrumb');
		const {isOpen} = cart.componentData;
		return (
		  <div className={styles.header}>
			  <ComponentCart data={cart} ref={this.cart} continueAction={this.props.breadCrumbContinue}/>
			  <ComponentBreadcrumb data={breadcrumb} continue={this.props.breadCrumbContinue} cartIsOpen={isOpen}/>
		  </div>
		)
	}
}

ComponentHeader.propTypes = {
	breadCrumbContinue: PropTypes.func
};


// React Context binding
ComponentHeader.contextType = ContextDataStore;

export default ComponentHeader;